module.exports = __webpack_public_path__ + "img/手表-6.c5e5322e.png";